import { useState } from 'react';

export interface UseToggle {
  isOpen: boolean;
  toggle: () => void;
}

const useToggle = (initialState = false): [UseToggle['isOpen'], UseToggle['toggle']] => {
  const [isShowing, setIsShowing] = useState(initialState);
  const toggleShowing = () => setIsShowing(!isShowing);

  return [isShowing, toggleShowing];
};

export { useToggle };
